/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */

import { ref } from '@vue/composition-api'
import Vue from 'vue'

export default function useSelectServer({ props, itens }) {
  const carregando = ref(false)
  const acessado = ref(false)

  /**
   * Carregar os itens do select trazendo do backend.
   * Utiliza cache para evitar requisições repetidas ao servidor.
   */
  const carregarItens = () => {
    // Se já acessou ou está carregando, não faz nova requisição
    if (acessado.value || carregando.value) {
      return
    }
    carregando.value = true
    props.request(props.filtros)
      .then(payload => {
        itens.value = [...payload.data]
        // Marca como acessado para usar cache nas próximas aberturas
        acessado.value = true
        carregando.value = false
      })
      .catch(err => {
        Vue.$errorFormated(err.response)
        carregando.value = false
        throw err
      })
  }

  /**
   * Carregar os itens do select filtrando pela busca feita pelo usuario.
   * Utiliza debounce para evitar requisições excessivas durante a digitação.
   */
  let debounceTimer = null
  const carregarItensFiltrados = digitado => {
    // Limpa timer anterior para implementar debounce
    if (debounceTimer) {
      clearTimeout(debounceTimer)
    }

    debounceTimer = setTimeout(() => {
      if (!carregando.value) {
        const novoFiltro = props.filtros.filter(fil => fil.soletrado)
        novoFiltro.forEach(each => {
          each.valor = digitado
        })
        carregando.value = true
        props.request(novoFiltro)
          .then(payload => {
            itens.value = [...payload.data]
            carregando.value = false
          })
          .catch(err => {
            carregando.value = false
            Vue.$errorFormated(err.response)
            throw err
          })
      }
    }, 300) // Aguarda 300ms após parar de digitar
  }

  return {
    carregando,
    carregarItens,
    carregarItensFiltrados,
  }
}
